// extracted by mini-css-extract-plugin
module.exports = {"rating":"StarRatingSelect_rating__Q9hEG","star":"StarRatingSelect_star__ZvRkA"};